import Vue from 'vue'
import CryptoJS from "crypto-js"
import router from '../router'
// 隨機字符串
export function randomString(len=32) {
    len = len || 32
    let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    let maxPos = $chars.length;
    let string = ''
    for (let i = 0; i < len; i++) {
        string += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
   return string;
}
// 頁面跳轉
export function jump(path){
    let check=path.substr(0,1)
    if(check!="/") path='/'+path
    router.push({ path: path })
}
// 獲取星期
export function week(date){
    var date=new Date(date.replace(/-|\./g, "/"))
    var key=date.getDay()
    let lang = Vue.prototype.global.lang
    var weekday=lang=="TC"?["週日","週一","週二","週三","週四","週五","週六"]:["周日","周一","周二","周三","周四","周五","周六"]
    return weekday[key]
}

// 日期加減
export function addDate(date, days, split=".",fill=true) {
    if (days == undefined || days == '') {
        days = 1
    }
    var date = new Date(date.replace(/\-|\./g, "/"))
    date.setDate(date.getDate() + days)
    var month = date.getMonth() + 1
    var day = date.getDate()
    if(fill){
        if(month<10) month="0"+month
        if(day<10) day="0"+day
    }
    return date.getFullYear() + split + month + split + day
}
// 時間差（秒）
export function DifferSeconds(time){
    var target = new Date(time.replace(/\-|\./g, "/"))
    var now = new Date()
    var seconds = Math.round((now.getTime() - target.getTime()) /1000)
    return seconds
}
export function FlightTimeDiffer(time_a,time_b){
    time_a=time_a.split(':')
    time_a=time_a[0]*60+time_a[1]
    time_b=time_b.split(':')
    time_b=time_b[0]*60+time_b[1]
    return Math.abs(time_a - time_b)
}
// 時間差（天）
export function DifferDays(a,b){
    a = new Date(a.replace(/\-|\./g, "/"))
    b = new Date(b.replace(/\-|\./g, "/"))
    return Math.abs(((a - b) / (1000 * 60 * 60 * 24)))
}

// 時間差（小时）
export function DifferHour(a,b){
    a = new Date(a.replace(/\-|\./g, "/"))
    b = new Date(b.replace(/\-|\./g, "/"))
    return Math.abs(((a - b) / (1000 * 60 * 60)))
}

export function busDifferTime(a,b){
    let aT = a.split(':')
    let bT = b.split(':')
    let dT = parseInt(bT[0])-parseInt(aT[0])
    let dM = 0
    console.log(parseInt(aT[1]))
    console.log(parseInt(bT[1]))
    if(parseInt(aT[1])>parseInt(bT[1])){
        dT--
        dM = parseInt(bT[1])+60-parseInt(aT[1])
    }else{
        dM = parseInt(bT[1])-parseInt(aT[1])
    }
    return [dT,dM]
}

// 獲取日期
export function formatDate(split="-",fill=false,date=null,mode=1) {
    date = date?new Date(date.replace(/\-|\./g, "/")):new Date()
    let myyear = date.getFullYear()
    let mymonth = date.getMonth() + 1
    let myweekday = date.getDate()
    if(fill){
        if (mymonth < 10) { mymonth = "0" + mymonth }
        if (myweekday < 10) { myweekday = "0" + myweekday }
    }
    let back_date
    switch(mode){
        case 1:
            back_date=myyear + split + mymonth + split + myweekday
        break
        case 2:
            back_date= mymonth + "月" + myweekday + "日"
        break
        case 3:
            back_date= mymonth + split + myweekday
        break
    }
    return back_date
}

export function isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
}
export function isWechat(){
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
}
export function token(){
    let token = localStorage.getItem('token')
    if(token){
        token = CryptoJS.AES.decrypt(token, Vue.prototype.global.secret_key)
        token = token.toString(CryptoJS.enc.Utf8);
        return token
    }
    return
}
export function voucher(){
    let voucher=sessionStorage.getItem('voucher')
    if(!voucher){
        voucher = localStorage.getItem('voucher')
        if(voucher){
            voucher = CryptoJS.AES.decrypt(voucher, Vue.prototype.global.secret_key)
            voucher = voucher.toString(CryptoJS.enc.Utf8)
            sessionStorage.setItem("voucher",voucher)
        }else{
            voucher = Vue.prototype.$cookies.get('voucher')
            if(voucher){
                localStorage.setItem('voucher',voucher)
                voucher = CryptoJS.AES.decrypt(voucher, Vue.prototype.global.secret_key)
                voucher = voucher.toString(CryptoJS.enc.Utf8)
                sessionStorage.setItem("voucher",voucher)
            }
        }
    }
    return voucher
}
export function save_login(data){
    let voucher = JSON.stringify(data)
    voucher = CryptoJS.AES.encrypt(voucher,Vue.prototype.global.secret_key).toString();
    localStorage.setItem('voucher',voucher)
    sessionStorage.setItem("voucher",JSON.stringify(data))
}
export function logout(){
    sessionStorage.removeItem('voucher')
    localStorage.removeItem('voucher')
    Vue.prototype.$cookies.remove('voucher')
    Vue.prototype.common.jump("/")
}
export function upload_action(path){
    return Vue.prototype.global.upload_url+path
}
export function upload_header(){
    return {'token': Vue.prototype.common.token() }
}
export function msg_date(date){
    if(!date) return
    let md = new Date(date.replace(/-/g, "/"))
    let nd = new Date()
    let dd = (nd.getTime() - md.getTime())/1000
    let Minutes,Hours,Month,Days
    if(dd<60){
        return "剛剛"
    }else if(dd>60&&dd<120){
        return "1分鐘前"
    }else if(dd>120&&dd<180){
        return "2分鐘前"
    }else if(dd>180&&dd<86400){
        Minutes = md.getMinutes()
        Minutes=Minutes<10?"0"+Minutes:Minutes
        Hours = md.getHours()
        Hours=Hours<10?"0"+Hours:Hours
        if(nd.getDate()!=md.getDate()){
            return "昨天 "+Hours+":"+Minutes
        }else{
            return Hours+":"+Minutes
        }
    }else{
        Month = md.getMonth()+1
        Month=Month<10?"0"+Month:Month
        Days = md.getDate()
        Days=Days<10?"0"+Days:Days
        Minutes = md.getMinutes()
        Minutes=Minutes<10?"0"+Minutes:Minutes
        Hours = md.getHours()
        Hours=Hours<10?"0"+Hours:Hours
        return Month+"-"+Days+" "+Hours+":"+Minutes
    }
}
export function msg_revoke(date){
    if(!date) return false
    let md = new Date(date.replace(/-/g, "/"))
    let nd = new Date()
    let dd = (nd.getTime() - md.getTime())/1000
    if(dd<120){
        return true
    }else{
        return false
    }
}
export function msg_last_date(date){
    if(!date) return
    date=date.split(" ")
    return date[0]
}
export function msg_last_time(date){
    if(!date) return
    date=date.split(" ")
    return date[1]
}
export function call_tel(numbers){
    window.location.href = 'tel://'+numbers
}

export function openid(){
    let openid = localStorage.getItem('hlgzh_openid')
    if(openid){
        openid = CryptoJS.AES.decrypt(openid, Vue.prototype.global.secret_key)
        openid = openid.toString(CryptoJS.enc.Utf8)
        return openid
    }else{
        return false
    }
}
export function openid_save(code){
    if(code){
        Vue.prototype.obtain.push(
            data=>{
                let openid = data.openid
                if(openid){
                    openid = CryptoJS.AES.encrypt(openid,Vue.prototype.global.secret_key).toString()
                    localStorage.setItem('hlgzh_openid', openid)
                    Vue.prototype.common.openid_edit(data.openid)
                }
            },"/app/wechat/openid",{ code: code },false
        )
    }
}
export function openid_edit(openid){
    let voucher = JSON.parse(Vue.prototype.common.voucher())
    if(!voucher.weinxi_id){
        Vue.prototype.obtain.push(e=>{
            voucher.weinxi_id = openid
            Vue.prototype.common.save_login(voucher)
        },"/app/members/edit",{id:voucher.id,weinxi_id:openid})
    }
}

export function isIos(){
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
}

export function spread_jump(data){
    switch(data.jump_page){
        case "car":
            Vue.prototype.common.jump('car_info/'+data.jump_params)
        break;
        case "tourism":
            Vue.prototype.common.jump('tourism_info/'+data.jump_params)
        break;
        case "buffet":
            Vue.prototype.common.jump('buffet_info/'+data.jump_params)
        break;
        case "concert":
            Vue.prototype.common.jump('concert_info/'+data.jump_params)
        break;
        case "coupon":
            Vue.prototype.common.jump('accounts_card/'+data.jump_params)
        break;
        case "activity":
            Vue.prototype.common.jump('xcf_info')
        break;
        case "network_card":
            Vue.prototype.common.jump('networkcard_info/'+data.jump_params)
        break;
        case "plane":
            Vue.prototype.common.jump('plane_info/'+data.jump_params)
        break;
        case "hotel_package":
            Vue.prototype.common.jump('hotel_package_info/'+data.jump_params)
        break;
        case "tickets":
            Vue.prototype.common.jump('tickets_info/'+data.jump_params)
        break;
        case "ticketsList":
            Vue.prototype.common.jump('tickets')
        break;
        case "bus":
            Vue.prototype.common.jump('bus')
        break;
        case "ferry":
            Vue.prototype.common.jump('ferry')
        break;
        case "hotelList":
            let sDate = formatDate("-",true)
            let eDate = addDate(sDate,1,"-")
            let hotelQuery = {
                area: null,
                city: "澳門",
                date: [sDate,eDate],
                e_date: formatDate('-',true,eDate,2),
                keyword: null,
                nationality: null,
                night: 1,
                price: null,
                s_date: formatDate('-',true,sDate,2),
                star: null,
                type: 0
            }
            localStorage.setItem('hotel_query', JSON.stringify(hotelQuery))
            let params = { city: "澳門" }
            let url = '/app/hotel/area'
            Vue.prototype.obtain.push(
                (data) => {
                    localStorage.setItem('select_area',JSON.stringify(data.data))
                    Vue.prototype.common.jump('hotel_lists')
                },url,params
            )
        break;
    }
}
export function orders_type_jump(type){
    switch (type) {
        case 1:
        Vue.prototype.common.jump('orders_networkcard')
        break
        case 2:
        Vue.prototype.common.jump('orders_bus')
        break
        case 3:
        Vue.prototype.common.jump('orders_hotel')
        break
        case 4:
        Vue.prototype.common.jump('orders_buffet')
        break
        case 5:
        Vue.prototype.common.jump('orders_car')
        break
        case 6:
        Vue.prototype.common.jump('orders_concert')
        break
        case 7:
        Vue.prototype.common.jump('orders_ferry')
        break
        case 8:
        Vue.prototype.common.jump('orders_tourism')
        break
        case 9:
        Vue.prototype.common.jump('orders_xcf')
        break
        case 10:
        Vue.prototype.common.jump('orders_plane')
        break
        case 11:
        Vue.prototype.common.jump('orders_hotel_package')
        break
        case 12:
        Vue.prototype.common.jump('orders_tickets')
        break
    }
}

export function settingTitle(model){
    let pageNameTemp = localStorage.getItem("pageName")
    if(pageNameTemp){
        pageNameTemp = JSON.parse(pageNameTemp)
        document.title = pageNameTemp[model]
    }
}

export default {
    randomString,jump,week,addDate,isMobile,DifferSeconds,formatDate,DifferDays,isWechat,token,voucher,save_login,upload_action,upload_header,logout,msg_date,msg_revoke,msg_last_date,msg_last_time,call_tel,FlightTimeDiffer,DifferHour,busDifferTime,openid,openid_save,isIos,openid_edit,spread_jump,orders_type_jump,settingTitle
}


// WEBPACK FOOTER //
// ./src/utils/common.js